import { useMemo } from "react"
import { Box, Stack, Tooltip, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { getCurrencySymbol } from "../format-utils"
import { RateCardTradeRow } from "./rate-card-trade-row"

export function RateCardTradeSection({ lines, currency, skillMapId, onUpdateLine, readOnly }) {
    const symbol = getCurrencySymbol(currency)
    const sortedLines = useMemo(sortByTradeName, [lines])

    return (
        <Box sx={{ mt: 2 }}>
            <Stack spacing={0.5} sx={{ mb: 1.5 }}>
                <Typography variant="subtitle1">Trade Rates</Typography>
                <Typography variant="body2" color="text.secondary">
                    Hourly rates or fixed annual contract terms for each mapped trade.
                </Typography>
            </Stack>
            <Box sx={{ overflowX: "auto", pb: 1 }}>
                <Box sx={{ minWidth: 860 }}>
                    <ListItemBox sx={{ bgcolor: "background.neutral", borderRadius: 1, px: 2, py: 1.5, gap: 2 }}>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: 16 }}>
                                Name
                            </Typography>
                        </Box>
                        <Box sx={{ width: 150, textAlign: "left" }}>
                            <Typography
                                variant="subtitle2"
                                color="text.secondary"
                                sx={{ fontSize: 16, whiteSpace: "nowrap" }}
                            >
                                Mode
                            </Typography>
                        </Box>
                        <Box sx={{ width: 320, textAlign: "right" }}>
                            <Tooltip
                                title="Hourly mode: hourly rate. Fixed annual mode: flat contract amount per year."
                                placement="top"
                            >
                                <Typography
                                    variant="subtitle2"
                                    color="text.secondary"
                                    sx={{ fontSize: 16, whiteSpace: "nowrap" }}
                                >
                                    Rate ({symbol})
                                </Typography>
                            </Tooltip>
                        </Box>
                        {/* Reserve the skill-overrides icon slot only when the rate card has a skill map (mirrors the row layout) */}
                        <If value={!!skillMapId}>
                            <Box sx={{ width: 30, flexShrink: 0 }} />
                        </If>
                        <Box sx={{ width: 30, flexShrink: 0 }} />
                    </ListItemBox>
                    <Repeat
                        list={sortedLines}
                        keyFn={getTradeKey}
                        item={
                            <RateCardTradeRow
                                currency={currency}
                                skillMapId={skillMapId}
                                onUpdateLine={onUpdateLine}
                                readOnly={readOnly}
                            />
                        }
                    />
                </Box>
            </Box>
        </Box>
    )

    function sortByTradeName() {
        return [...(lines || [])].sort((a, b) => (a.tradeName || "").localeCompare(b.tradeName || ""))
    }
}

// Trade rows are keyed by tradeId so per-row state (skillsOpen, notesOpen) survives parent re-renders that hand down a fresh item object.
function getTradeKey(item) {
    return item.tradeId
}
